<template>
    <div class="mh_wrapper" :class="{ active: active }">
        <div class="mh_header" @click="toggle">
            <i class="material-icons mh_left mh_handler">
                reorder
            </i>
            <div v-if="module_active" class="mh_title"><strong>{{title}}</strong></div>
            <div v-else class="mh_title">{{title}}</div>
            <i class="material-icons mh_right">
                arrow_drop_down
            </i>
        </div>
        <div class="mh_content">
            <slot />
        </div>
        <div class="mh_footer" @click="toggle">
            <i class="material-icons">
                arrow_drop_up
            </i>
        </div>
    </div>
</template>

<script>
export default {
    data: function() {
        return {
            active: false,
            title: ''
        }
    },
    created: function() {
        this.title = this.$attrs.module_title;
        this.module_active = this.$attrs.module_active;
    },
    methods: {
        toggle: function() {
            this.active = !this.active;
        }
    }
}
</script>

<style lang="scss">
.mh_wrapper {

    user-select: none;

    .mh_header,
    .mh_footer {
        background-color: #eeeeee;
        cursor: pointer;
    }
    .mh_content
    {
        max-height: 0;
        overflow: hidden;
        transition: all 1.5s;
    }
    .mh_header {
        padding: 5px 5px 5px 33px;
        margin-bottom: 10px;
        position: relative;

        i.mh_right {
            position: absolute;
            right: 3px;
            top: 1px;
            transform: rotate(-90deg);
            transition: transform 0.5s;
        }

        i.mh_left {
            position: absolute;
            top: 1px;
            left: 3px;
            color: #bbbbbb;
        }
    }
    .mh_footer {
        text-align: right;
        margin: 0;
        padding-right: 5px;
        transition: all 0.5s;
        max-height: 0;
        overflow: hidden;

    }

    &.active {
        .mh_header {
            i.mh_right {
                transform: rotate(0deg);
            }
        }
        .mh_content {
            max-height: 2000px;
        }
        .mh_footer {
            margin: 10px 0;
            max-height: 100px;
        }
    }
}
</style>


